import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { CART_BOX_BUILDER_POPUP } from 'swag-client-common/constants';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isResellerAdminLoggedInModeSelector } from 'swag-client-common/redux/user/user.selectors';
import { onCloseBoxBuilderPopup, saveEditedBoxItems, saveNewBoxToCart, saveSelectedCartItemsToBox, selectBackButton, showSuperSpeedBoxConfirmation } from '../../../../../redux/box-builder/box-builder.actions';
import { currentBoxesQuantitySelector, currentSpecialBoxProductSelector, currentStepSelector, productCardItemsSelector, addonCardItemsSelector, isDisableBoxBuilderNextButtonSelector, editBoxBuilderItemsIdSelector, hasUnsavedChangesSelector, otherSpecialBoxProductsSelector, isAddonStepRestrictedSelector, shouldShowSuperSpeedBoxConfirmationSelector } from '../../../../../redux/box-builder/box-builder.selectors';
import { STEPS } from '../../../../../redux/box-builder/box-builder.constants';
import Footer from './footer';
import { getFooterPrices } from './get-footer-prices.util';
const footerPricesSelector = createSelector(currentBoxesQuantitySelector, productCardItemsSelector, addonCardItemsSelector, currentSpecialBoxProductSelector, otherSpecialBoxProductsSelector, getFooterPrices);
const mapStateToProps = createStructuredSelector({
  prices: footerPricesSelector,
  boxId: editBoxBuilderItemsIdSelector,
  hasUnsavedChanges: hasUnsavedChangesSelector,
  quantityOfBoxes: currentBoxesQuantitySelector,
  isDisabledNextButton: isDisableBoxBuilderNextButtonSelector,
  currentStep: currentStepSelector,
  isAddonStepRestricted: isAddonStepRestrictedSelector,
  shouldShowSuperSpeedBoxConfirmation: shouldShowSuperSpeedBoxConfirmationSelector,
  isResellerAdminLoggedInMode: isResellerAdminLoggedInModeSelector
});
const mapDispatchToProps = (dispatch, {
  isAddonFlow = false
}) => ({
  onBackButton: currentStep => {
    dispatch(selectBackButton(currentStep));
    if (currentStep === STEPS.SELECT_PRODUCTS_FOR_BOX) {
      dispatch(showPopup({
        popup: CART_BOX_BUILDER_POPUP
      }));
    }
  },
  onNextButton: ({
    boxId,
    hasUnsavedChanges,
    isAddonStepRestricted,
    shouldShowSuperSpeedBoxConfirmation
  }) => {
    if (isAddonFlow) {
      if (boxId) {
        if (hasUnsavedChanges) {
          return dispatch(saveEditedBoxItems({
            boxId,
            isCart: true
          }));
        }
        onCloseBoxBuilderPopup(dispatch)(false);
      } else {
        return dispatch(saveNewBoxToCart());
      }
    } else {
      if (shouldShowSuperSpeedBoxConfirmation) {
        return dispatch(showSuperSpeedBoxConfirmation());
      }
      if (isAddonStepRestricted) {
        if (boxId) {
          return dispatch(saveEditedBoxItems({
            boxId,
            isCart: true
          }));
        } else {
          return dispatch(saveNewBoxToCart());
        }
      }
    }
    return dispatch(saveSelectedCartItemsToBox());
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(Footer);